<script setup lang="ts">
import type { IProps } from './EventCalendarCards.types'
import AddToCalendarButton from '@/domains/investor/event-calendar/components/AddToCalendarButton/AddToCalendarButton.vue'
import { formatDate } from '@/utils/date'

defineProps<IProps>()

</script>

<template>
  <ul class="eventCalendarCards">
    <li
      v-for="event in events"
      :key="event.id"
      class="eventCalendarCards__card"
    >
      <div class="eventCalendarCards__header">
        <span class="eventCalendarCards__date">
          {{ formatDate(event.date) }}
        </span>

        <p class="eventCalendarCards__title">
          {{ event.title }}
        </p>
      </div>

      <span class="eventCalendarCards__divider" />

      <AddToCalendarButton
        class="eventCalendarCards__button"
        :event="event"
      />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.eventCalendarCards {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 0;
  list-style: none;

  &__card {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    padding: 1.6rem 2.4rem;
    background-color: $white;
    border: 1px solid $gray-300;
    border-radius: 1.2rem;
  }

  &__header {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  &__date {
    @include body-3;
    color: $text-200;
  }

  &__title {
    @include body-2;
    color: $text-400;
  }

  &__divider {
    width: 100%;
    height: 0.1rem;
    background-color: $gray-300;
  }

  &__button {
    align-self: flex-start;
  }
}
</style>
